import { Controller } from 'stimulus';
import debounce from '@/helpers/debounce';

class MultiSelectController extends Controller {
  connect() {
    this.searchDebounced = debounce((q) => {
      this.searchOptions(q.length > 2 ? q : '');
    }, 200);

    this.outputSelectedOptions();
  }

  onWindowClick({ target }) {
    if (target.closest('[data-controller="multi-select"]')) return;

    $(this.collapseTarget).collapse('hide');
  }

  onSearchKeyup(e) {
    this.searchDebounced(e.currentTarget.value);
  }

  onOptionChange() {
    this.outputSelectedOptions();
  }

  searchOptions(q) {
    const normalizedSearch = MultiSelectController.normalizeSearch(q);

    this.optionTargets.forEach((option) => {
      if (q === '') {
        option.parentNode.style.display = 'block';

        return;
      }

      const normalizedLabel = MultiSelectController.normalizeSearch(option.dataset.label);
      const inLabel = normalizedLabel.indexOf(normalizedSearch) >= 0;

      option.parentNode.style.display = inLabel ? 'block' : 'none';
    });
  }

  outputSelectedOptions() {
    const selectedOptionLabels = this.optionTargets
      .map((option) => {
        if (!option.checked || typeof option.dataset.label === 'undefined') {
          return null;
        }

        return option.dataset.label;
      })
      .filter((option) => option);

    this.triggerTarget.innerText = selectedOptionLabels.length
      ? selectedOptionLabels.join(', ')
      : this.data.get('title');
  }

  static normalizeSearch(string) {
    return string.toLowerCase().trim().replace(/[\s-]/g, '');
  }
}

MultiSelectController.targets = [
  'option',
  'trigger',
  'collapse',
];

export default MultiSelectController;
